import axios from "axios";
window.components.searchcontainer = {
    selector: "div[searchpage]",
    isLoadedByAjax: false,

    init: function () {
        this.events();
    },

    events: function () {
        $(this.selector).find(".content-link").on("click", this.onClickContent);
        $(this.selector)
            .find(".load-more-action")
            .on("click", this.onLoadMoreClick);
    },

    onClickContent: function (e) {
        e.preventDefault();
        $(".search-content, div").removeClass("active");
        $(".filters, .content-link").removeClass("active");
        const containerid = `#${$(this).attr("data-containerid")}`;
        const loadMoreLink = $(`${containerid} .load-more-action`);
        const url = loadMoreLink.attr("data-nextpage");
        if (!url) {
            loadMoreLink.attr("style", "display:none");
        }

        $(containerid).toggleClass("active");
        $(this).toggleClass("active");
    },

    onLoadMoreClick: function (e) {
        e.preventDefault();
        const nextPage = $(this).attr("data-nextpage");
        axios
            .get(nextPage, {
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                if (response.data.renderedContent) {
                    const container = `#${response.data.category}-container`;
                    $(`${container} .resultpage`).append(
                        response.data.renderedContent
                    );
                    if (response.data.hasMorePages) {
                        $(`${container} .load-more-action`).attr(
                            "data-nextpage",
                            response.data.nextPageUrl
                        );
                    } else {
                        $(`${container} .load-more-action`).attr(
                            "style",
                            "display:none"
                        );
                    }
                }
            });
    },
};
